{
  "de": {
    "texts": {
      "user": {
        "maintainer": "Erhält das Maintainer-Abzeichen und alle Vorteile für Unterstützer der höchsten Stufe."
      },
      "index": "Deine Datenbank für alle Informationen rund um Schiffe und Stationen in Star Citizen.",
      "support": {
        "info": "Kein Geld übrig? <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Gib uns eine Stimme auf Spectrum</b></a> und hilf mehr Leuten, FleetYards zu finden.",
        "goal": "Deckt laufende Kosten wie Server-Hosting und Datendienste.",
        "code": "Neu bei Star Citizen? Nutze diesen Code für 5000 UEC Startguthaben:",
        "thisMonth": "von %{goal} in diesem Monat",
        "subline": "Unterstütze uns direkt",
        "anonymousSupporters": {
          "one": "%{count} anonymer Unterstützer",
          "other": "%{count} anonyme Unterstützer"
        },
        "otherWays": "Andere Wege zu helfen"
      },
      "appLoadFailed": "Ein Teil von FleetYards konnte nicht geladen werden, daher sieht diese Seite vielleicht falsch aus oder reagiert nicht richtig. Lade sie neu, um das zu beheben. Falls das nicht hilft, schließe die App und öffne sie erneut.",
      "appUpdate": {
        "withCodename": "FleetYards %{version} (%{codename}) ist live. Lade die Seite neu, um zu wechseln.",
        "plain": "FleetYards %{version} ist live. Lade die Seite neu, um zu wechseln."
      },
      "installApp": {
        "eventSignup": "Installiere FleetYards als App, um mit einem Tipp zu deinen Events zurückzukehren.",
        "iosIntro": "Auf iPhone und iPad installierst du Apps wie FleetYards über das Teilen-Menü:",
        "iosShare": "Tippe in der Browserleiste auf „Teilen“.",
        "iosAdd": "Wähle „Zum Home-Bildschirm“. Eventuell musst du dafür nach unten scrollen.",
        "iosConfirm": "Tippe auf „Hinzufügen“. FleetYards öffnet sich jetzt wie jede andere App vom Home-Bildschirm."
      },
      "supportHint": {
        "hangarSync": "Background-Syncs sind der größte Posten unserer Hosting-Rechnung. FleetYards läuft auf Spendenbasis — jeder Beitrag hilft.",
        "vehicleAdded": "FleetYards ist kostenlos und werbefrei und finanziert sich ausschließlich über Spenden. Wenn dir die Seite hilft, freuen wir uns über deine Unterstützung.",
        "fleetCreated": "Flotten sind eine unserer aufwendigsten Funktionen. FleetYards bleibt dank Spenden kostenlos und werbefrei — ein kleiner Beitrag hilft enorm.",
        "loginMilestone": "Schön, dass du regelmäßig vorbeischaust — danke dir. FleetYards finanziert sich über Spenden; falls du helfen möchtest, hier entlang.",
        "visitMilestone": "FleetYards ist community-finanziert — keine Werbung, keine Paywalls. Wenn dir die Seite gefällt, hilft schon eine kleine Spende."
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "Deine Freigabe deckt diesen Bereich nicht ab. Wird eine Funktion gerade erst ausgerollt, kannst du sie unter Einstellungen > Funktionen selbst aktivieren, sobald sie für dich verfügbar ist.",
      "subscriptionRequired": "Aufträge, Events, Logistics und Touren werden von den Leuten getragen, die FleetYards unterstützen. Diese Flotte ist derzeit nicht abgedeckt — ein Beitrag von einem einzigen Mitglied schaltet alle vier für die ganze Flotte frei.",
      "featureNotReady": "Diese Funktion ist noch nicht fertig und wird bald verfügbar sein. Bleiben Sie dran!",
      "inviteInvalid": "Dieser Einladungslink ist nicht gültig. Möglicherweise wurde er falsch übertragen, er ist abgelaufen oder er hat sein Nutzungslimit erreicht. Bitte lass dir von der Person, die dich eingeladen hat, einen neuen Link geben.",
      "accessDenied": "Sie sind nicht berechtigt, diese Seite anzuzeigen.",
      "serverError": "Der Server hat derzeit technische Probleme. Bitte versuchen Sie es später erneut.",
      "offline": "Die Anfrage hat den Server nicht erreicht. Dein Gerät scheint offline zu sein oder der Server war nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.",
      "invalidRequest": "Der Server konnte diese Anfrage nicht verarbeiten. Lade die Seite neu und versuche es erneut.",
      "invalidListRequest": "Dieser Filter oder diese Sortierung ist ungültig. Setze sie zurück, um die Liste wieder anzuzeigen.",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        },
        "components": {
          "info": "Wähle bis zu acht Komponenten einer Kategorie, etwa Schilde oder Quantenantriebe, um sie nebeneinander zu vergleichen."
        },
        "equipment": {
          "info": "Wähle bis zu acht Ausrüstungsgegenstände einer Art, etwa Gewehre oder Helme, um sie nebeneinander zu vergleichen."
        },
        "dropped": "%{items} entfernt: Dieser Vergleich umfasst nur eine Kategorie, %{category}."
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin.",
        "directory": "Verifizierte Flotten, die gefunden werden möchten. Jede Flotte hier hat nachgewiesen, dass sie ihre RSI-Organisation leitet."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "Die Wiederherstellung einer endgültig gelöschten Flotte erfolgt nach bestem Bemühen. Rollen, Bilder, Einladungslinks und Flottenfahrzeuge werden nicht wiederhergestellt."
        },
        "models": {
          "viewsFolder": {
            "hint": "Lege hier einen Ordner mit Ansichten namens top.png, side.png, front.png und angled.png ab. Suffix _colored für den lackierten Satz, Präfix extended_ für die ausgefahrene und landed_ für die gelandete Variante. Das Präfix flight_ oder gar kein Präfix landet im Standardsatz. holo.gltf wird mit denselben Präfixen ebenfalls übernommen. Die Ansichten von hinten und unten heißen angled_rear.png, bottom.png, rear.png und starboard.png. holo_lite.glb, das Holo ohne Innenraum, nimmt dieselben Präfixe; holo_textured.glb landet nur im Standardsatz, ebenso holo.usdz, das Holo für AR auf iPhone und iPad.",
            "uploading": {
              "one": "Eine Datei wird hochgeladen…",
              "other": "%{count} Dateien werden hochgeladen…"
            },
            "matched": {
              "one": "Eine Datei bereit — zum Anwenden speichern.",
              "other": "%{count} Dateien bereit — zum Anwenden speichern."
            },
            "processing": {
              "one": "Eine Ansicht wird im Hintergrund zugeschnitten — sie wird hier aktualisiert, sobald sie fertig ist.",
              "other": "%{count} Ansichten werden im Hintergrund zugeschnitten — sie werden hier aktualisiert, sobald sie fertig sind."
            },
            "processed": "Alle Ansichten sind verarbeitet.",
            "ignored": "Ignoriert: %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "Der Grund wird der Person angezeigt, die die Anwendung registriert hat — benenne also, was sich ändern muss."
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "Willkommen in deinem Hangar",
          "text": "Dein Hangar behält den Überblick über alle Schiffe, die du besitzt. Diese kurze Tour zeigt dir, wo alles ist — du kannst sie jederzeit über den ?-Button erneut starten."
        },
        "add": {
          "title": "Schiffe hinzufügen",
          "text": "Wähle ein oder mehrere Schiffe und jeweils die Anzahl. Auf der Seite oder Karte jedes Schiffs fügt das Lesezeichen-Symbol es ebenfalls deinem Hangar oder deiner Wunschliste hinzu."
        },
        "sync": {
          "title": "Mit RSI synchronisieren",
          "text": "Synchronisiere Schiffe, Lackierungen, Flair und Ausrüstung von RSI mit der FleetYards-Browsererweiterung. Prüfe danach das Ergebnis. Rückkäufe haben eine eigene Synchronisierung auf der Rückkaufseite."
        },
        "display": {
          "title": "Anzeigeoptionen",
          "text": "Wechsle zwischen Karten und Liste, lege deine Standardsortierung fest und wähle, welche Details oder Spalten angezeigt werden. In der Liste kannst du mehrere Schiffe auswählen und gemeinsam ändern."
        },
        "groups": {
          "title": "Gruppen",
          "text": "Sortiere deine Schiffe mit + und dem Stift in eigene Gruppen. Klicke auf eine Gruppe, um danach zu filtern, oder fahre darüber, um ihre Schiffe hervorzuheben."
        },
        "vehicle": {
          "title": "Das Menü jedes Schiffs",
          "text": "Hier bearbeitest du ein Schiff: benennen, Lackierung wählen, zum Flaggschiff machen, Sichtbarkeit setzen, Loadouts verwalten oder auf die Wunschliste verschieben."
        },
        "wishlist": {
          "title": "Wunschliste",
          "text": "Schiffe, die du haben möchtest, aber noch nicht besitzt, kommen auf deine Wunschliste. Verschiebe sie in deinen Hangar, sobald du sie erwirbst."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Stelle deine Schiffe maßstabsgetreu nebeneinander und speichere das Chart als Bild."
        },
        "pages": {
          "title": "Hangar-Seiten",
          "text": "Statistiken, Wunschliste, Inventare, Blaupausen und die aus deinem RSI-Hangar synchronisierten Gegenstände haben jeweils eine eigene Seite im Hangar-Bereich der Navigation."
        },
        "share": {
          "title": "Hangar teilen",
          "text": "Teile deinen öffentlichen Hangar und lege fest, welche Schiffe und Gruppen erscheinen. In den Hangar-Einstellungen kannst du außerdem einen geheimen Link erstellen, ersetzen oder deaktivieren, der auch bei privatem Hangar funktioniert. Jeder mit diesem Link kann deinen Hangar und seine Statistiken sehen."
        },
        "menu": {
          "title": "Mehr",
          "text": "Importiere oder exportiere deinen Hangar, prüfe den Importverlauf und öffne deinen RSI-Hangar. Auf dem Smartphone findest du hier auch Wunschliste, Fleetchart und diese Tour."
        },
        "overview": {
          "title": "Die eigene Seite deines Schiffs",
          "text": "Klicke auf den Schiffstitel, um die Übersicht zu öffnen und Konfiguration und Sichtbarkeit zu verwalten, Einträge im Kapitänslogbuch zu schreiben und ein Bild hochzuladen. Gib einem eigenen Schiff eine Widmungsplakette und speichere sie als Bild. Logbucheinträge haben eigene Sichtbarkeitseinstellungen."
        },
        "reset": {
          "title": "Nach einem Wipe im Spiel",
          "text": "Setze hier deine im Spiel gekauften Schiffe zurück: Verschiebe alle auf die Wunschliste als Einkaufsliste oder entferne sie aus deinem Hangar. Mit Echtgeld gekaufte Schiffe bleiben erhalten."
        },
        "exampleShip": {
          "title": "Beispielschiff",
          "text": "Nur für die Tour. Dieses Schiff wird nicht in deinem Hangar gespeichert."
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "Deine Flotte ist bereit",
          "text": "Diese Tour öffnet jede Seite, auf der du sie einrichtest, und zeigt auf das, worauf es dort ankommt. Das Fragezeichen oben auf der Flottenseite startet sie jederzeit erneut."
        },
        "events": {
          "title": "Events und Missionen",
          "text": "Plane Operationen, lass Mitglieder sich für ein Schiff und einen Platz eintragen und behalte alles im Flottenkalender."
        },
        "contracts": {
          "title": "Aufträge",
          "text": "Stelle Aufträge für deine Mitglieder ein und zahle sie aus, sobald sie erledigt sind."
        },
        "members": {
          "title": "Mitglieder einladen",
          "text": "Lade Leute über ihren Fleetyards-Benutzernamen ein oder erstelle einen Einladungslink zum Teilen auf Discord oder RSI. Beitrittsanfragen landen ebenfalls auf dieser Seite."
        },
        "ships": {
          "title": "Schiffe und Flottenübersicht",
          "text": "Die Schiffe, die deine Mitglieder teilen, ergeben zusammen die Schiffe der Flotte. Die Flottenübersicht stellt sie maßstabsgetreu nebeneinander."
        },
        "membership": {
          "title": "Deine Schiffe in der Flotte",
          "text": "Jedes Mitglied entscheidet, welche seiner Schiffe die Flotte sieht: alle, eine Hangar-Gruppe oder keine. Hier triffst du deine eigene Wahl."
        },
        "rsi": {
          "title": "RSI-Organisation verifizieren",
          "text": "Gib die SID deiner Organisation ein und verifiziere sie. Die Verifizierung beweist, dass die Organisation dir gehört, und schützt deine Flotten-ID."
        },
        "roles": {
          "title": "Rollen",
          "text": "Jede Rolle legt fest, was ihre Mitglieder sehen und verwalten dürfen. Diese Seite zeigt, was jede Rolle kann."
        },
        "squadrons": {
          "title": "Staffeln und Teams",
          "text": "Schalte Staffeln ein, um die Mitglieder in Einheiten und Teams mit eigenen Rängen aufzuteilen."
        },
        "discord": {
          "title": "Discord verbinden",
          "text": "Installiere den Bot auf deinem Discord-Server, um jedem Rang eine Discord-Rolle zu geben und Events als geplante Events zu spiegeln."
        },
        "settings": {
          "title": "Öffentliche Flottenseite",
          "text": "Lege fest, ob die Flottenseite und ihre Schiffe öffentlich sind; Logo, Beschreibung und Links findest du ebenfalls hier."
        },
        "finish": {
          "title": "Deine Flotte ist eingerichtet",
          "text": "Das ist alles für den Start. Das Fragezeichen hier oben startet diese Tour jederzeit erneut."
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "Mit RSI synchronisieren",
          "text": "Importiere deine Pledges mit der Browsererweiterung oder einer hangarXPLOR-Datei, statt Schiffe einzeln hinzuzufügen."
        },
        "organise": {
          "title": "Schiffe organisieren",
          "text": "Benenne deine Schiffe, lege Lackierungen, Loadouts und ein Flaggschiff fest und sortiere sie in eigene Gruppen."
        },
        "wishlist": {
          "title": "Wunschliste und Sales",
          "text": "Behalte die Schiffe, die du willst, auf einer Wunschliste und werde benachrichtigt, wenn sie im Sale sind."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Sieh deine Schiffe maßstabsgetreu nebeneinander und speichere das Chart als Bild."
        },
        "stats": {
          "title": "Hangar-Statistiken",
          "text": "Rollen, Hersteller, Größen und was du ausgegeben hast, auf einen Blick."
        },
        "share": {
          "title": "Öffentlicher Hangar",
          "text": "Teile deinen Hangar per Link — du entscheidest, welche Schiffe und Gruppen sichtbar sind."
        }
      },
      "fleetPreview": {
        "members": {
          "title": "Mitglieder und Rollen",
          "text": "Lade deine Org-Mitglieder per Link ein und organisiere sie mit Rollen und Staffeln."
        },
        "ships": {
          "title": "Flottenschiffe",
          "text": "Alle öffentlichen Schiffe deiner Mitglieder in einer filter- und durchsuchbaren Liste."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Sieh die ganze Flotte maßstabsgetreu nebeneinander und speichere sie als Bild."
        },
        "stats": {
          "title": "Flottenstatistiken",
          "text": "Analysiere deine Flotte nach Rolle, Größe und Frachtkapazität."
        },
        "allies": {
          "title": "Verbündete",
          "text": "Verbünde dich mit anderen Flotten und behalte im Blick, mit wem du fliegst."
        },
        "discord": {
          "title": "Discord",
          "text": "Poste Ankündigungen und eine wöchentliche Zusammenfassung auf deinem Discord-Server und lass Mitglieder über eine Rolle beitreten."
        }
      },
      "impressum": {
        "visit": "Besuch",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "Welche Informationen verwenden wir?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "Als Gast",
          "text": "Als Gast auf %{app} sammeln wir die folgenden Daten:"
        },
        "analytics": {
          "headline": "Nutzungsstatistik",
          "basis": "%{app} zählt Seitenaufrufe, um zu verstehen, welche Bereiche der Seite tatsächlich genutzt werden. Grundlage dafür ist unser berechtigtes Interesse am Betrieb und an der Verbesserung der Seite, nicht deine Einwilligung: Die Daten werden ausschließlich von uns selbst erhoben, IP-Adressen werden vor dem Speichern anonymisiert, es werden keine Cookies oder andere Kennungen auf deinem Gerät abgelegt und nichts wird an Werbenetzwerke weitergegeben.",
          "retention": "Einzelne Besuche und Seitenaufrufe werden nach einem Monat gelöscht. Darüber hinaus bleiben nur aggregierte Zahlen erhalten, die sich keiner Person mehr zuordnen lassen. Die einzige Ausnahme ist eine einzelne Zahl an deinem Konto: wie viele Wochen in Folge du es genutzt hast, gezählt ab deinem letzten Besuch. Aktivität vor einer solchen Serie wird nicht aufbewahrt, und die Zahl wird auf null gesetzt, sobald du widersprichst. Mit dem Löschen deines Kontos werden auch die dazu erfassten Besuche gelöscht.",
          "objection": {
            "headline": "Wie du widersprichst",
            "text": "Du kannst der Nutzungsstatistik jederzeit widersprechen. Wir hören dann auf, sie zu erfassen, statt sie nur auszublenden.",
            "user": "Die Einstellung in deinem Konto gilt auf allen Geräten, auf denen du angemeldet bist.",
            "guest": "Ohne Konto kannst du hier widersprechen. Wir beachten außerdem das Global-Privacy-Control-Signal, wenn dein Browser es sendet."
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "Zählt anonymisiert, welche Seiten du besuchst, ohne etwas auf deinem Gerät zu speichern. Besuche werden nach einem Monat gelöscht.",
          "onlineStatus": "Zeigt den Mitgliedern deiner Flotten und deinen Freunden einen Punkt neben deinem Namen, solange du FleetYards geöffnet hast. Deine letzte Aktivität bleibt in jedem Fall sichtbar.",
          "supporterListed": "Ob dein Benutzername — nie der Name, mit dem du bezahlt hast — auf der Unterstützerseite erscheint. Verborgene Spenden zählen trotzdem zum Ziel, und Patreon-Unterstützungen bleiben verborgen, solange du sie nicht anzeigst."
        },
        "notifications": {
          "hint": "Lege fest, wie dich jedes Ereignis erreicht. App-Benachrichtigungen sammeln sich in deinem Benachrichtigungscenter, E-Mails gehen an die Adresse deines Kontos.",
          "push": {
            "title": "Push-Benachrichtigungen",
            "intro": "Erhalte Benachrichtigungen auf diesem Gerät, auch wenn FleetYards geschlossen ist. Welche als Push ankommen, legst du unten in der Spalte Push fest.",
            "unsupported": "Push-Benachrichtigungen sind in diesem Browserfenster nicht verfügbar. Versuche, FleetYards als installierte App auf deinem Computer, Smartphone oder Tablet zu öffnen.",
            "unavailable": "Push-Benachrichtigungen sind auf diesem FleetYards-Server nicht eingerichtet.",
            "denied": "Benachrichtigungen sind für FleetYards in diesem Browser blockiert. Erlaube sie in den Website-Einstellungen des Browsers und lade die Seite dann neu.",
            "on": "Push-Benachrichtigungen sind für dieses Gerät aktiviert.",
            "off": "Push-Benachrichtigungen sind für dieses Gerät deaktiviert.",
            "device": "%{browser} auf %{os}",
            "unknownDevice": "Unbekannter Browser",
            "thisDevice": "(dieses Gerät)",
            "failed": "Der Status der Push-Benachrichtigungen für dieses Gerät konnte nicht geprüft werden. Lade die Seite neu, um es erneut zu versuchen."
          }
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "Um die Zwei-Faktor-Authentifizierung zu deaktivieren, geben Sie einfach einen gültigen Token ein.",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} fordert Zugriff auf Ihr Konto an.",
        "scopesIntro": "Diese Anwendung wird in der Lage sein:"
      },
      "buybackSync": {
        "info": "Liest jede Seite deiner RSI-Rückkaufliste und ersetzt damit die auf Fleetyards gespeicherten Rückkauf-Pledges. Dein Hangar bleibt unverändert. Lange Listen dauern einige Minuten. Die Synchronisierung läuft im Hintergrund: Du kannst dieses Fenster schließen und Fleetyards weiter nutzen, solange der Tab offen bleibt.",
        "unsupported": "Deine Fleetyards-Sync-Erweiterung kann Rückkauf-Pledges noch nicht lesen. Aktualisiere sie, um sie zu synchronisieren.",
        "detailsInfo": "Die erste Synchronisierung liest außerdem Preis und Versicherung jedes Pledges, je eine RSI-Seite. Bei einer langen Liste kann das eine Viertelstunde dauern. Spätere Synchronisierungen lesen nur die neuen.",
        "detailsUnsupported": "Aktualisiere deine Fleetyards-Sync-Erweiterung, um auch Preise und Versicherungen zu lesen.",
        "detailsIncomplete": "Einige Preise konnten nicht von RSI gelesen werden. Die nächste Synchronisierung versucht es erneut.",
        "detailsBackground": "Preise und Versicherungen werden jetzt im Hintergrund gelesen. Du kannst dieses Fenster schließen und Fleetyards weiter nutzen; lass den Tab offen, bis es fertig ist.",
        "detailsRunning": "Preise und Versicherungen der letzten Synchronisierung werden noch gelesen. Eine neue Synchronisierung kann starten, sobald das abgeschlossen ist.",
        "sessionHint": "Die Synchronisierung liest deine Rückkaufliste über diese Sitzung.",
        "pointReplace": "Liest jede Seite deiner RSI-Rückkaufliste und ersetzt damit die hier gespeicherten Rückkauf-Pledges.",
        "pointUntouched": "Dein Hangar bleibt unverändert.",
        "pointBackground": "Läuft im Hintergrund: Du kannst dieses Fenster schließen, lass nur den Tab offen.",
        "finished": "Deine Rückkauf-Pledges entsprechen deiner RSI-Liste.",
        "keepsRunning": "Es läuft weiter, wenn du dieses Fenster schließt. Lass den Tab offen, bis es fertig ist."
      },
      "blueprintAddToHangar": {
        "ownHint": "Du hast diese Blaupause.",
        "wishlistHint": "Du möchtest diese Blaupause bekommen.",
        "unownHint": "Du hast diese Blaupause nicht mehr.",
        "unwantHint": "Du möchtest diese Blaupause nicht mehr."
      },
      "addToHangar": {
        "hangarHint": "Du besitzt dieses Schiff.",
        "wishlistHint": "Du möchtest dieses Schiff später haben."
      },
      "resetIngame": {
        "info": "Ein Wipe nimmt dir die Schiffe, die du ingame gekauft hast. Verschiebe sie auf deine Wunschliste, um sie später erneut zu kaufen, oder entferne sie aus deinem Hangar. Schiffe, die du nicht ingame gekauft hast, bleiben unverändert."
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "alreadyRunning": "Eine Hangar-Synchronisierung läuft bereits. Bitte warten Sie, bis sie abgeschlossen ist.",
        "missingUnmatchedGroup": "Wähle vor dem Start die Gruppe, in die Schiffe einsortiert werden, die die Synchronisierung nicht findet.",
        "signedOutTitle": "Du bist nicht bei RSI angemeldet",
        "signedOut": "Melde dich in diesem Browser auf der RSI-Website an und prüfe dann erneut.",
        "sessionHint": "Die Synchronisierung liest deine Pledges über diese Sitzung.",
        "finished": "Dein Hangar entspricht deinen RSI-Pledges. Alles wurde zugeordnet.",
        "unmatched": "Alles andere wurde synchronisiert. Nichts von dem unten Aufgeführten wurde deinem Hangar hinzugefügt.",
        "partialFailure": "Einige Änderungen sind möglicherweise schon in deinem Hangar. Ein erneuter Versuch ist sicher: Bereits synchronisierte Schiffe werden wieder zugeordnet, nicht doppelt hinzugefügt.",
        "pointMatch": "Findet die Schiffe aus deinem RSI-Hangar, die schon hier sind, anhand von Name und Pledge-ID.",
        "pointAdd": "Fügt die hinzu, die noch nicht hier sind."
      },
      "setEmail": "Um ein Passwort festzulegen, Zwei-Faktor-Authentifizierung zu aktivieren oder E-Mail-Benachrichtigungen zu erhalten, musst du eine E-Mail-Adresse zu deinem Konto hinzufügen. Du erhältst eine Bestätigungs-E-Mail zur Verifizierung.",
      "oauthApplications": {
        "pendingReview": "Diese Anwendung ist registriert und wartet auf die Prüfung. Bis zur Freigabe kann sie keinen Zugriff anfragen.",
        "rejected": "Diese Anwendung wurde abgelehnt und kann keinen Zugriff anfragen. Wer behebt, was im Grund steht, landet wieder in der Warteschlange.",
        "returnedToReview": "Wird die Redirect-URI oder werden die Scopes geändert, geht eine freigegebene Anwendung zurück in die Prüfung."
      },
      "payouts": {
        "accountFound": "%{username} hat ein FleetYards-Konto und wird mit diesem Teilnehmer verknüpft.",
        "accountMissing": "Kein FleetYards-Konto hat diesen Benutzernamen. Prüfe die Schreibweise oder füge die Person unten per Name als Gast hinzu.",
        "guestHint": "Für jemanden ohne FleetYards-Konto. Die Person wird als Gast geführt.",
        "deleteHint": "Auf dieser Tour ist noch niemand sonst, daher kann sie gelöscht werden.",
        "tourInvite": "%{username} lädt dich zu dieser Tour ein.",
        "contractReady": "Der Auftrag ist erfüllt. Öffne sein Auszahlungsbuch, um die Belohnung an die Auftragnehmer auszuzahlen.",
        "contractNotReady": "Für diesen Auftrag wurde noch kein Auszahlungsbuch eröffnet.",
        "expenseNeedsReview": "Eine Ausgabe zählt, sobald sie von der Verwaltung des Buchs freigegeben wurde."
      },
      "fleet": {
        "contractCovers": "Das Bild, das die Auftragstafel je Auftragsart zeigt. Bleibt eines leer, wird das eingebaute Bild darunter verwendet."
      },
      "vehicleLog": {
        "visibility": "Öffentliche Einträge werden bei diesem Schiff in deinem öffentlichen Hangar angezeigt.",
        "visibilityHidden": "Dieses Schiff steht nicht in deinem öffentlichen Hangar, daher wird dort keiner seiner Einträge angezeigt.",
        "empty": "Halte fest, was diesem Schiff passiert ist — nur du siehst einen Eintrag, bis du ihn öffentlich machst.",
        "publicEmpty": "Der Kapitän dieses Schiffs hat noch keine Logbucheinträge geteilt.",
        "noneForFilter": "Keine Einträge für diesen Filter.",
        "unavailable": "Dieses Logbuch ist gerade nicht verfügbar."
      },
      "vehiclePlaque": {
        "supporter": "Alle weiteren Stile sind ein Dankeschön an alle, die Fleetyards am Laufen halten.",
        "keptStyle": "Deine Tafel behält ihren Stil %{style}, ein Dankeschön an Unterstützer. Beim Speichern wechselt sie zu %{default}.",
        "credits": {
          "founders": "%{manufacturer}-Gründer",
          "shipwrights": "%{manufacturer}-Schiffbauer",
          "designers": "%{manufacturer}-Konstrukteure",
          "directors": "%{manufacturer}-Direktion"
        },
        "fromFleet": "Aus einer Flotte",
        "classLine": "%{model} von %{manufacturer}",
        "commissioned": "In Auftrag gegeben bei %{shipyard}",
        "launched": "Vom Stapel gelaufen im %{date}",
        "launchedAt": "Vom Stapel gelaufen im %{date}, %{port}",
        "launchedFrom": "Vom Stapel gelaufen in %{port}",
        "captain": "Captain %{name}",
        "captainOf": "Captain %{name}, %{affiliation}",
        "year": "%{month} %{year}",
        "empty": "Noch keine Widmung. Schreib eine, und das Schiff bekommt seine Tafel.",
        "visibility": "Solange das Schiff öffentlich ist, sieht jeder die Tafel in deinem öffentlichen Hangar."
      },
      "vehicleOverview": {
        "noLoadouts": "Noch keine Loadouts. Verknüpfe eins von Erkul oder SPViewer.",
        "locationPrivate": "Nur du siehst, wo dein Schiff steht.",
        "pickReplacesUpload": "Ein Bild aus der Galerie oder eine Lackierung ersetzt dein hochgeladenes Bild.",
        "galleryEmpty": "Für dieses Schiff gibt es noch keine Galeriebilder."
      },
      "model": {
        "sectionEmpty": "%{model} hat keine %{section}."
      },
      "hangarPledgeItems": {
        "addToInventory": "Jeder Eintrag wird so oft hinzugefügt, wie sein Pledge ihn enthält.",
        "alreadyInInventory": {
          "one": "%{count} Eintrag ist bereits in einem Inventar und bleibt dort.",
          "other": "%{count} Einträge sind bereits in einem Inventar und bleiben dort."
        },
        "noInventories": "Du hast noch kein Inventar. Lege eines an und füge dann deine Einträge hinzu."
      },
      "plaqueTool": {
        "intro": "Gib jedem Schiff eine Widmungsplakette. Wähle ein Schiff, schreibe seine Widmung und teile die Plakette als Bild.",
        "pickShip": "Wähle ein Schiff, um seine Plakette zu zeichnen.",
        "signIn": "Melde dich an, um diese Plakette an einem Schiff in deinem Hangar anzubringen.",
        "noShips": "In deinem Hangar und auf deiner Wunschliste ist kein Schiff vom Typ %{model}, an dem die Plakette angebracht werden kann.",
        "attachIntro": "Die Plakette kommt an das Schiff, das du wählst, unter dessen eigenem Namen und Kennung.",
        "addShip": "Füge eines hinzu, und es bekommt die Plakette, unter dem Namen und der Kennung, die du ihr gegeben hast.",
        "example": "Ein Beispiel: die Plakette, die Cloud Imperium für The Only Constant aufgehängt hat, ihren Prototyp der Constellation Phoenix. Ändere eine beliebige Zeile, um sie zu deiner zu machen."
      }
    }
  }
}
